// Mapeo de insignias por libro y actividad a las imágenes correspondientes
export const BADGE_IMAGES: { [bookNumber: number]: { [activityNumber: number]: string } } = {
    1: {
        1: "/images/insignias/libro1/EscuderoDulcerodelReino.png",
        2: "/images/insignias/libro1/InsigniadelAlquimistadelLimonajeReal.png",
        3: "/images/insignias/libro1/InsigniadelBardodelaCorteReal.png",
        4: "/images/insignias/libro1/InsigniadelGuardiándePerspectivas.png",
        5: "/images/insignias/libro1/InsigniadelGuardiandelTesoroReal.png",
        6: "/images/insignias/libro1/InsigniadelHeraldodelaVerdad.png",
        7: "/images/insignias/libro1/InsigniadelMensajeroRealdelaGravedad.png"
    },
    2: {
        1: "/images/insignias/libro2/Decisordedilemas.png",
        2: "/images/insignias/libro2/DetectiveCríticodelBosque.png",
        3: "/images/insignias/libro2/EscultordeSoluciones.png",
        4: "/images/insignias/libro2/GuardiandelaAbudancia.png",
        5: "/images/insignias/libro2/IngenieroMaestro.png",
        6: "/images/insignias/libro2/InventordelClaro.png",
        7: "/images/insignias/libro2/MediadordelBosque.png"
    },
    3: {
        1: "/images/insignias/libro3/ArquitectodeSoluciones.png",
        2: "/images/insignias/libro3/CartógrafodeArgumentos.png",
        3: "/images/insignias/libro3/Cazapreguntas.png",
        4: "/images/insignias/libro3/CorazónGeneroso.png",
        5: "/images/insignias/libro3/ExploradordeEcos.png",
        6: "/images/insignias/libro3/Pacificador.png",
        7: "/images/insignias/libro3/ZorroAtrevido.png"
    },
    4: {
        1: "/images/insignias/libro4/AlasCuriosas.png",
        2: "/images/insignias/libro4/AtalayaIndestructible.png",
        3: "/images/insignias/libro4/CentinelaEstoico.png",
        4: "/images/insignias/libro4/CuelloErguido.png",
        5: "/images/insignias/libro4/GuardiándelaSerenidad.png",
        6: "/images/insignias/libro4/PlumasdeSabiduría.png",
        7: "/images/insignias/libro4/RioEncauzado.png"
    },
    5: {
        1: "/images/insignias/libro5/ChispaIntrépida.png",
        2: "/images/insignias/libro5/CompartidorSonriente.png",
        3: "/images/insignias/libro5/CorazónRespetuoso.png",
        4: "/images/insignias/libro5/EscuderodelaPaz.png",
        5: "/images/insignias/libro5/GuardíandelMinuto.png",
        6: "/images/insignias/libro5/MagoSinérgico.png",
        7: "/images/insignias/libro5/TejedordeAmistades.png"
    },
    6: {
        1: "/images/insignias/libro6/ArquitectodeSueños.png",
        2: "/images/insignias/libro6/BuscadordeTesoros.png",
        3: "/images/insignias/libro6/ControldeCalidad.png",
        4: "/images/insignias/libro6/ForjadordeAlianzas.png",
        5: "/images/insignias/libro6/InstrumentistadelÉxito.png",
        6: "/images/insignias/libro6/MaestroEstratega.png",
        7: "/images/insignias/libro6/PensadordeSoluciones.png"
    },
    7: {
        1: "/images/insignias/libro7/CampeóndelaConstancia.png",
        2: "/images/insignias/libro7/CorazóndeCampeón.png",
        3: "/images/insignias/libro7/CustodiodelOrden.png",
        4: "/images/insignias/libro7/EstrelladelDescanso.png",
        5: "/images/insignias/libro7/MaestrodelAseo.png",
        6: "/images/insignias/libro7/OráculoNutricional.png",
        7: "/images/insignias/libro7/PaladíndelCuerpo.png"
    },
    8: {
        1: "/images/insignias/libro8/AliadodeProducción.png",
        2: "/images/insignias/libro8/CustodiodeVisión.png",
        3: "/images/insignias/libro8/DescubridordeHuevosdeOro.png",
        4: "/images/insignias/libro8/DetectivedelInterés.png",
        5: "/images/insignias/libro8/MaestrodeMetas.png",
        6: "/images/insignias/libro8/PlanificadorFinanciero.png",
        7: "/images/insignias/libro8/VisionarioVeloz.png"
    }
};

// Función para obtener la imagen de una insignia específica
export function getBadgeImage(bookNumber: number, activityNumber: number): string {
    return BADGE_IMAGES[bookNumber]?.[activityNumber] || '';
}

// Función para obtener el nombre de la insignia basado en el libro y actividad
export function getBadgeName(bookNumber: number, activityNumber: number): string {
    const badgeImage = getBadgeImage(bookNumber, activityNumber);
    if (!badgeImage || badgeImage === '') return "Insignia";
    
    // Extraer el nombre del archivo sin extensión
    const fileName = badgeImage.split('/').pop()?.replace('.png', '') || '';
    
    // Convertir el nombre del archivo a un formato legible
    return fileName
        .replace(/([A-Z])/g, ' $1') // Agregar espacio antes de mayúsculas
        .replace(/^./, str => str.toUpperCase()) // Primera letra en mayúscula
        .trim();
}
